import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled as muiStyled } from "@mui/material/styles";
import { useState } from "react";
import { saveConnorsApplyPrefs } from "./connorsStorage";
import {
  ButtonRow,
  CheckboxRow,
  CloseButton,
  CloseIconStyled,
  CollectiveTitle,
  ConfirmationText,
  ConfirmButton,
  DialogContent,
  DialogStyled,
  DisclaimerText,
  LogoImage,
} from "./styles";

const WhiteCheckbox = muiStyled(Checkbox)({
  color: "rgba(255, 255, 255, 0.7)",
  "&.Mui-checked": {
    color: "#ffffff",
  },
});

function ConnorsApplyConfirmDialog({ open, onClose, onConfirm }) {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  const handleYes = () => {
    if (doNotShowAgain) {
      saveConnorsApplyPrefs();
    }
    setDoNotShowAgain(false);
    onConfirm();
    onClose();
  };

  const handleNo = () => {
    setDoNotShowAgain(false);
    onClose();
  };

  const handleDialogClose = (_, reason) => {
    if (reason === "backdropClick") {
      return;
    }

    handleNo();
  };

  return (
    <DialogStyled
      open={open}
      onClose={handleDialogClose}
      data-testid="connors-apply-confirm-dialog"
    >
      <DialogContent>
        <CloseButton
          onClick={handleNo}
          aria-label="Close"
          data-testid="connors-apply-confirm-close"
        >
          <CloseIconStyled />
        </CloseButton>

        <LogoImage
          src="https://assets.wobbjobs.com/images/connors-logo.png"
          alt="Connor's Stout Porter"
        />

        <CollectiveTitle>Collective</CollectiveTitle>

        <ConfirmationText>
          I CONFIRM THAT I AM NON-MUSLIM
          <br />
          AND AGED 21 YEARS OLD AND ABOVE
        </ConfirmationText>

        <ButtonRow>
          <ConfirmButton
            type="button"
            onClick={handleNo}
            data-testid="connors-apply-confirm-no"
          >
            No, I am not
          </ConfirmButton>
          <ConfirmButton
            type="button"
            onClick={handleYes}
            data-testid="connors-apply-confirm-yes"
          >
            Yes, I am
          </ConfirmButton>
        </ButtonRow>

        <CheckboxRow>
          <FormControlLabel
            control={
              <WhiteCheckbox
                checked={doNotShowAgain}
                onChange={(event) => setDoNotShowAgain(event.target.checked)}
                inputProps={{
                  "data-testid": "connors-apply-confirm-dont-show",
                }}
              />
            }
            label="Do not show again"
            sx={{
              margin: 0,
              "& .MuiFormControlLabel-label": {
                fontSize: "0.875rem",
                color: "rgba(255, 255, 255, 0.85)",
                paddingTop: "5px",
                fontFamily:
                  '"Hops and Barley C4", "Helvetica Neue", Helvetica, Arial, sans-serif',
              },
            }}
          />
        </CheckboxRow>

        <DisclaimerText>
          PLEASE SHARE THIS SITE ONLY WITH INDIVIDUALS AGED 21+ AND THOSE WHO
          ARE NON-MUSLIMS. IF YOU DRINK, DON&apos;T DRIVE.
          <br />
          <b>#CELEBRATE</b>RESPONSIBLY
          <br />
          <br />
          CARLSBERG MARKETING SDN BHD 198501008089 (140534-M) NO. 55, PERSIARAN
          SELANGOR, SEKSYEN 15, 40200 SHAH ALAM, SELANGOR, MALAYSIA.
        </DisclaimerText>
      </DialogContent>
    </DialogStyled>
  );
}

export default ConnorsApplyConfirmDialog;
